import { useCountdown } from "@/hooks/useCountdown";
import { Skeleton } from "@/components/ui/skeleton";
import type { NextPrayer } from "@/types/prayer";

interface Props {
  nextPrayer: NextPrayer | null;
  loading: boolean;
}

export function CountdownTimer({ nextPrayer, loading }: Props) {
  const { hours, minutes, seconds } = useCountdown(
    nextPrayer?.time ?? null
  );

  if (loading) {
    return (
      <div className="text-center space-y-2">
        <Skeleton className="h-6 w-32 mx-auto" />
        <Skeleton className="h-14 w-48 mx-auto" />
      </div>
    );
  }

  if (!nextPrayer) return null;

  return (
    <div className="text-center space-y-1">
      <p className="text-sm text-muted-foreground">
        Time remaining until{" "}
        <span className="font-medium text-foreground">
          {nextPrayer.name}
        </span>
      </p>
      <p className="text-5xl font-mono font-bold tabular-nums tracking-tight">
        {String(hours).padStart(2, "0")}:
        {String(minutes).padStart(2, "0")}:
        {String(seconds).padStart(2, "0")}
      </p>
    </div>
  );
}
